"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfMathUtils = void 0;
var RtfMathUtils = (function () {
    function RtfMathUtils() {
    }
    RtfMathUtils.getShortValue = function (value) {
        return value & 0x7FFF;
    };
    RtfMathUtils.isShortValue = function (value) {
        return value == RtfMathUtils.getShortValue(value);
    };
    RtfMathUtils.getUInt16 = function (value) {
        return 0xffff & value;
    };
    return RtfMathUtils;
}());
exports.RtfMathUtils = RtfMathUtils;
